import { useMutation, useQuery } from "@tanstack/vue-query"

import { FlowStagesRequest, FlowStagesResponse } from "@finq/app-base/types/flow-stages.types"

export function useFetchFlowStage(
  params: { flowKey: Ref<string>; stage?: Nullable<string> },
  options?: QueryOptions<FlowStagesResponse>
) {
  const { flowKey } = params || {}
  return useQuery<FlowStagesResponse>({
    queryKey: ["FlowStagesService.getCurrentStage", flowKey],
    queryFn: ({ signal }) => FlowStagesService.getCurrentStage(flowKey.value, { signal }),
    staleTime: 0,
    ...options,
  })
}

export function useUpdateFlowStage(
  params: { flowKey: Ref<string> },
  options?: MutationOptions<FlowStagesResponse, Error, FlowStagesRequest>
) {
  const { flowKey } = params || {}
  return useMutation({
    mutationKey: ["FlowStagesService.updateStage", flowKey],
    mutationFn: (data) => FlowStagesService.updateStage(flowKey.value, data),
    ...options,
  })
}
